import Cloudprinter from '../../services/CloudprinterService'
import _ from 'lodash'

const convertMessage = (reject) => {
  const defaultMessage = 'An error occurred. Please contact us <a class="link" href="https://www.cloudprinter.com/knowledge/kb-tickets/new" target="_blank">here</a>.';

  if (!reject.message) {
    return defaultMessage;
  }

  return reject.message.replace('[Contact us]', 'Please contact us <a class="link" href="https://www.cloudprinter.com/knowledge/kb-tickets/new" target="_blank">here</a>.');
};

const initialState = () => ({
  cpOrderShipping: [],
  cp_product_category: null,
  cp_product_sub_category: null,
  cp_product_reference: null,
  type: 'pod',
  cp_product_options: {},
  quantity: null,
  shipping_address: {
    'firstname': null,
    'lastname': null,
    'company': null,
    'email': null,
    'phone': null,
    'country': null,
    'state': null,
    'city': null,
    'street1': null,
    'street2': null,
    'zip': null,
    'customerIdentification': null
  },
  quotes: {},
  product_price: null,
  total_price: 0,
  vat: 0,
  mode: null,
  order_reference: null,
  cpProductInfo: {},
  stateIsRequired: false,
  priceCheckErrors: [],
  priceCheckResponse: null,
  cpCountries: [],
  cpStates: [],
  editMode: false,
  editProductIndex: null
})

const state = initialState()

const actions = {
  clearProductData (context) {
    context.commit('clearProductData')
  },

  setProductData (context, productData) {
    Cloudprinter.getProductInfo(productData.cp_product_reference)
      .then((response) => {
        productData['cpProductInfo'] = response.data;
        productData['shipping_address'] = _.cloneDeep(context.rootGetters['cart/address'])
        context.commit('setProductData', productData)
      })
  },

  enableEditMode (context, productIndex) {
    context.commit('enableEditMode', productIndex)
  },

  disableEditMode (context) {
    context.commit('disableEditMode')
  },

  priceCheckForCartItems (context) {
    let items = context.rootGetters['cart/itemsForPriceCheck']
    return context.dispatch('priceCheck', items)
  },

  priceCheckAfterAddNewProduct (context) {
    let items = [...context.rootGetters['cart/itemsForPriceCheck']]
    let newItem = context.getters['orderItem']
    newItem = _.omit(newItem, ['files'])
    newItem.reference = items.length + 1
    items.push(newItem)
    return context.dispatch('priceCheck', items)
  },

  setAddress (context, addressData) {
    context.commit('setAddress', addressData)
  },

  setCountry (context, country) {
    let shippingAddress = context.rootGetters['cpOrder/shippingAddress']
    shippingAddress.country = country
    context.commit('setAddress', shippingAddress)
  },

  setState (context, state) {
    let shippingAddress = context.rootGetters['cpOrder/shippingAddress']
    shippingAddress.state = state
    context.commit('setAddress', shippingAddress)
  },

  // Deprecated
  priceCheck (context, items) {
    let priceCheckData = {
      'country': context.state.shipping_address.country || context.rootGetters['cart/country'],
      'items': items
    }

    if (context.state.stateIsRequired || context.rootGetters['cart/state']) {
      priceCheckData.state = context.state.shipping_address.state || context.rootGetters['cart/state']
    }

    const priceCheck = Cloudprinter.priceCheck(priceCheckData)

    priceCheck.then(response => {
      let data = {}
      // Todo. Remove this condition when CPMAIN-112 is done.
      if (response.data.error) {
        data = {
          priceCheckErrors: 'The shipping is not possible. Please, contact support.',
          priceCheckResponse: null
        }
      } else {
        data = {
          priceCheckErrors: [],
          priceCheckResponse: response.data
        }
      }
      context.commit('updatePriceCheckData', data)
    }).catch(error => {
      const priceCheckErrors = []

      if ( error.response.data.error && error.response.data.error.errors && error.response.data.error.errors.length ) {
        error.response.data.error.errors
          .forEach((reject) => {
            priceCheckErrors.push(convertMessage(reject))
          })
      } else if (error.response.data.error.info) {
        priceCheckErrors.push(error.response.data.error.info)
      }

      if (priceCheckErrors.length === 0) {
        priceCheckErrors.push('This product is unavailable for order now or there is an issue on our side. Please contact us <a class="link" href="https://www.cloudprinter.com/knowledge/kb-tickets/new" target="_blank">here</a>')
      }

      const data = {
        priceCheckErrors,
        priceCheckResponse: null
      }
      context.commit('updatePriceCheckData', data)
    })

    return priceCheck
  },

  updatePriceCheckData (context, data) {
    context.commit('updatePriceCheckData', data)
  }
}

const mutations = {
  updatePriceCheckData (state, data) {
    state.priceCheckErrors = data.priceCheckErrors
    state.priceCheckResponse = data.priceCheckResponse
  },

  clearProductData (state) {
    state.cp_product_category = null
    state.cp_product_sub_category = null
    state.cp_product_reference = null
    state.cp_product_options = {}
    state.quantity = null
    state.cpProductInfo = {}
    state.quotes = {}
    state.cpOrderShipping = []
    state.priceCheckResponse = null
  },

  // Deprecated
  setProductData (state, productData) {
    state.cp_product_category = productData.cp_product_category
    state.cp_product_sub_category = productData.cp_product_sub_category
    state.cp_product_reference = productData.cp_product_reference
    state.cp_product_options = productData.cp_product_options
    state.quantity = productData.quantity
    state.shipping_address = productData.shipping_address
    state.cpProductInfo = productData.cpProductInfo
    state.type = productData.type
  },

  setAddress (state, addressData) {
    state.shipping_address = addressData
  },

  enableEditMode (state, productIndex) {
    state.editMode = true
    state.editProductIndex = productIndex
  },

  disableEditMode (state) {
    state.editMode = false
    state.editProductIndex = null
  }
}

const getters = {
  allData: state => {
    return state
  },

  quotes: state => {
    return state.quotes
  },

  cpOrderShipping: state => {
    return state.cpOrderShipping
  },

  countryName: state => {
    for (let country of state.cpCountries) {
      if (country.country_reference === state.shipping_address.country) {
        return country.note
      }
    }
  },

  stateName: state => {
    for (let stateItem of state.cpStates) {
      if (stateItem.state_reference === state.shipping_address.state) {
        return stateItem.note
      }
    }
  },

  shippingAddress: (state, getters) => {
    let shippingData = {
      'type': 'delivery',
      'company': state.shipping_address.company,
      'firstname': state.shipping_address.firstname,
      'lastname': state.shipping_address.lastname,
      'street1': state.shipping_address.street1,
      'street2': state.shipping_address.street2,
      'zip': state.shipping_address.zip,
      'city': state.shipping_address.city,
      'country': state.shipping_address.country,
      'email': state.shipping_address.email,
      'phone': state.shipping_address.phone
    }

    if (getters.customerIdentificationIsSupported) {
      shippingData.customer_identification = state.shipping_address.customerIdentification
    }

    if (state.stateIsRequired) {
      shippingData.state = state.shipping_address.state
    }

    return shippingData
  },

  orderItem: state => {
    let item = {
      'reference': '1',
      'product_reference': state.cp_product_reference,
      'count': state.quantity,
      'options': []
    }

    let options = []
    for (let key in state.cp_product_options) {
      if (key === 'count_pages') {
        options.push({
          'option_reference': 'total_pages',
          'count': state.cp_product_options[key]
        })
      } else if (['total_pages', 'archive_total_files'].indexOf(key) !== -1) {
        options.push({
          'option_reference': key,
          'count': state.cp_product_options[key]
        })
      } else {
        options.push({
          'option_reference': state.cp_product_options[key],
          'count': 1
        })
      }
    }

    item.options = options

    return item
  },

  customerIdentificationIsSupported: state => {
    // Todo: Take the countries from the API.
    return ['BR', 'TW'].indexOf(state.shipping_address.country) !== -1;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
